import { createAction, Action } from 'redux-actions';

export interface ILoginSuccessPayload {
  token: string;
  email: string;
}

export const actionTypes = {
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  SETUP_ACCOUNT_SUCCESS: 'SETUP_ACCOUNT_SUCCESS',
  UPDATE_PASSWORD_SUCCESS: 'UPDATE_PASSWORD_SUCCESS',
  RESET_PASSWORD_ERROR: 'RESET_PASSWORD_ERROR',
  UPDATE_LOGIN_AFTER_IDLE: 'UPDATE_LOGIN_AFTER_IDLE',
  GET_USER_PROFILE_SUCCESS: 'GET_USER_PROFILE_SUCCESS',
  RESET_ALL_AFTER_LOGOUT: 'RESET_ALL_AFTER_LOGOUT',
};

export const loginSuccess: (
  payload: ILoginSuccessPayload,
) => Action<ILoginSuccessPayload> = createAction(actionTypes.LOGIN_SUCCESS);

export const loginError: (payload: string) => Action<string> = createAction(
  actionTypes.LOGIN_ERROR,
);

export const setupAccountSuccess: () => Action<void> = createAction(
  actionTypes.SETUP_ACCOUNT_SUCCESS,
);

export const updatePasswordSuccess: () => Action<void> = createAction(
  actionTypes.UPDATE_PASSWORD_SUCCESS,
);

export const resetPasswordError: (payload: string) => Action<string> =
  createAction(actionTypes.RESET_PASSWORD_ERROR);

export const updateLoginAfterIdle: (payload: boolean) => Action<boolean> =
  createAction(actionTypes.UPDATE_LOGIN_AFTER_IDLE);

export const getUserProfileSuccess: (
  payload: UserProfileDTO,
) => Action<UserProfileDTO> = createAction(
  actionTypes.GET_USER_PROFILE_SUCCESS,
);

export const resetAllAfterLogout: () => Action<void> = createAction(
  actionTypes.RESET_ALL_AFTER_LOGOUT,
);
